import {  ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { finalize } from 'rxjs';
import Currencies from 'src/assets/data/currencies.json';
import { MomentService } from 'src/app/shared/services/moment.service';
@Component({
  selector: 'app-uob-duitnow-proxy',
  templateUrl: './duitnow-proxy.component.html',
  styles: [],
  standalone: false
})
export class DuitnowProxyComponent implements OnInit {
  private momentService = inject(MomentService);
  bankAccs: any[] = [];
  currencyOptions: any[] = [];
  private _data: any = {};
  get data(): any {
    return this._data;
  }
  @Input() set data(val: any) {
    this._data = val;

    this.form.patchValue({
      // payeeName: val.payeeName,
      currency: val.local.currency,
      payeeCurrency: val.local.currency,
      amount: val.local.amount
      //payForCode: val.payForCode
    });
  }
  form = this.fb.group({
    account: ['', [Validators.required, Validators.maxLength(30)]],
    accountCurrency: ['', []],
    payeeCurrency: [{ value: '', disabled: false }, [Validators.required]],
    proxyType: ['BREG', [Validators.required, Validators.maxLength(31)]],
    proxyValue: ['', [Validators.required, Validators.maxLength(40)]],
    isResident: [true, [Validators.required]],
    transferDate: [new Date(), [Validators.required]],
    currency: ['', [Validators.required]],
    amount: [
      0,
      [
        Validators.required,
        Validators.min(0.01),
        Validators.max(9999999999999.99)
      ]
    ],
    payeeRef: ['', [Validators.required, Validators.maxLength(35)]]
  });

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    this.momentService.moment().diff(current, 'days') > 0;

  constructor(
    private fb: FormBuilder,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.form.controls.account.valueChanges.subscribe(val => {
      if (val) {
        const bank = this.bankAccs.find(x => x.bankAccountNo === val);
        if (bank) {
          this.form.controls.accountCurrency.setValue(bank.currencyCode);
        }
      }
    });
  }

  ngOnInit(): void {
    this.currencyOptions = Currencies.filter(x => x.code).map(x => {
      return { label: x.code, value: x.code };
    });
    this.loadBankAccounts();
  }

  private loadBankAccounts() {
    let url = `api/accountcodes/search?$top=10&$skip=0&$orderby=code asc`;
    var filter = `IsActive eq true and BankTypeCode eq 'UOB' and CurrencyCode eq 'MYR' and BankAccountNo ne null and BankAccountNo ne '' and LocalCurrency eq true`;
    url = `${url}&$filter=${filter}`;
    this.http
      .get(url)
      .pipe(
        finalize(() => {
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        if (res.value) {
          res.value.forEach((item: any) => {
            item.label = `${item.bankAccountNo} (${item.currencyCode})`;
          });

          this.bankAccs = [...res.value];
        }
      });
  }
}
